import { decodeCompressedJson } from './url-codec.js';
import type { SchemaInput } from './schema-input.js';

/** Saved bodies can be legacy compressed links or complete JSON documents. */
export async function decodeSavedMapData(data: string): Promise<SchemaInput | null> {
  if (!data.trim().startsWith('{')) return decodeCompressedJson(data, { reportError: false });
  try { return JSON.parse(data); } catch { return null; }
}
